import React from 'react';
import { Field, mergeClasses, Radio, RadioGroup } from '@fluentui/react-components';
import { MessageBar, MessageBarBody, MessageBarTitle } from '@fluentui/react-message-bar';

import { HelpButton } from '@bingads-webui-react/help-popup';
import { useDataSource } from '@bingads-webui-react/data-source';

import { useHeaderControlStyles } from './header-control-styles';
import { Scopes } from '../constants';
import { I18n } from '../types';

const scopeOptions = {
  [Scopes.ACCOUNT]: _TL_('Use the account "Include in conversions" setting'),
  [Scopes.CAMPAIGN]: _TL_('Choose conversion goals for this campaign'),
};

interface HeaderControlComponentProps {
  i18n: I18n;
  scope: string | undefined;
  setScope: (value)=> void;
  showNoMainGoalWarning: boolean;
}

export const HeaderControlComponent: React.FC<HeaderControlComponentProps> = ({
  i18n, scope, setScope, showNoMainGoalWarning,
}) => {
  const {
    refetch, search,
  } = useDataSource();

  const classes = useHeaderControlStyles();
  const onChangeInternal = (_, data) => {
    setScope(data.value);
    search('');
    // @ts-ignore
    refetch();
  };

  return (
    <div className={mergeClasses('goal-scope-header', classes.header)}>
      <Field label={
        <div className={classes.title}>{i18n.getString(_TL_('Select conversion goals for this campaign'))}
          <span className={classes.required} aria-hidden="true" aria-label={i18n.getString(_TL_('Reqired'))}>*</span>
          <HelpButton
            aria-label={i18n.getString(_TL_('Learn more'))}
            topic="pop_BA_PMAX_ConversionsGoal_Campaign"
          />
        </div>
      }
      >
        <RadioGroup value={scope} onChange={onChangeInternal}>
          {Object.keys(scopeOptions).map((key, idx) =>
            <Radio value={key} key={key} label={i18n.getString(scopeOptions[key])} id={`conversion-goal-options-${idx}`} />)}
        </RadioGroup>
        {showNoMainGoalWarning && (
          <MessageBar intent="warning" className="warning-bar" layout="multiline">
            <MessageBarBody>
              <MessageBarTitle>{i18n.getString(_TL_('No account level conversion goals'))}</MessageBarTitle>
              {i18n.getString(_TL_('If there is no account-level conversion goal, you need to choose a specific conversion goal for this campaign.'))}
            </MessageBarBody>
          </MessageBar>
        )}
      </Field>
    </div>
  );
};
